export interface FeaturesMegaMenuLinkProps {
  title: string;
  subtitle: string;
  href: string;
}

const FeaturesMegaMenuLinksData: FeaturesMegaMenuLinkProps[] = [
  {
    title: 'Courses',
    subtitle: 'Premium learning experiences',
    href: '/features/online-courses',
  },
  {
    title: 'Events',
    subtitle: 'Create moments that matter',
    href: '/features/events',
  },
  {
    title: 'Members',
    subtitle: 'Profiles built for connection',
    href: '/features/members',
  },
  {
    title: 'Chat',
    subtitle: 'Interactions on every level',
    href: '/features/chat',
  },
  {
    title: 'Feed',
    subtitle: 'Endless engagement on tap',
    href: '/features/feed',
  },
  {
    title: 'Livestreaming',
    subtitle: 'No-stress streaming, anytime',
    href: '/features/livestream',
  },
  {
    title: 'Payments & Affiliates',
    subtitle: 'Quick setup, flexible options',
    href: '/features/payments',
  },
  {
    title: 'Automations',
    subtitle: 'Put growth on autopilot',
    href: '/features/automations',
  },
  {
    title: 'Embeds',
    subtitle: '2,000+ options available',
    href: '/features/embeds',
  },
  {
    title: 'People Magic AI',
    subtitle: 'The only AI designed to create member connections',
    href: '/features/ai',
  },
  {
    title: 'Integrations',
    subtitle: 'Easy connections with your existing tech stack',
    href: '/features/integrations',
  },
  {
    title: 'Analytics',
    subtitle: 'Meaningful insights to help you grow your community',
    href: '/features/analytics',
  },
];

export default FeaturesMegaMenuLinksData;
